

// Test data for Level 1 Driver Training

export const driverTests = [
  {
    id: "driver-practice",
    title: "Driver au practice",
    description: "Sur le practice, taper 10 balles avec un driver vers une cible à 220 m, compter le nombre de balles qui arrivent autour de la cible.",
    icon: "🏌️‍♂️"
  },
  {
    id: "driver-accuracy",
    title: "Précision au driver",
    description: "Sur le practice, taper 10 balles avec un driver à 220 m en visant un couloir de 40 m de large, compter les balles qui restent dans le couloir.",
    icon: "🏌️‍♂️"
  }
];

